import type { IconType } from '@/lib/icons'
import { LayoutGrid, Rows3, Search, X } from '@/lib/icons'
import { cn } from '@/lib/utils'

export type VideoView = 'list' | 'kanban'

interface VideoToolbarProps {
  searchInput: string
  onSearchInputChange: (value: string) => void
  view: VideoView
  onViewChange: (view: VideoView) => void
}

/** Qidiruv qutisi + Kanban/List almashtirgich — `docs/03-app-flow.md` "Sahifa 2" yuqori paneli. */
export function VideoToolbar({
  searchInput,
  onSearchInputChange,
  view,
  onViewChange,
}: VideoToolbarProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <div className="relative flex-1">
        <Search
          size={16}
          className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-app-hint"
          aria-hidden="true"
        />
        <input
          type="text"
          inputMode="search"
          value={searchInput}
          onChange={(event) => onSearchInputChange(event.target.value)}
          placeholder="Qidirish: bloger, @username..."
          aria-label="Videolarni qidirish"
          className="h-11 w-full rounded-input border border-app-border bg-app-bg pr-9 pl-9 text-base text-app-text placeholder:text-app-hint outline-none focus-visible:border-brand"
        />
        {searchInput.length > 0 && (
          <button
            type="button"
            onClick={() => onSearchInputChange('')}
            aria-label="Qidiruvni tozalash"
            className="absolute top-1/2 right-1.5 flex size-11 -translate-y-1/2 items-center justify-center rounded-button text-app-hint hover:bg-app-card"
          >
            <X size={16} aria-hidden="true" />
          </button>
        )}
      </div>

      <div
        role="group"
        aria-label="Ko'rinishni tanlash"
        className="inline-flex h-11 shrink-0 items-center gap-1 rounded-button border border-app-border p-1"
      >
        <ViewButton
          label="Kanban"
          icon={LayoutGrid}
          active={view === 'kanban'}
          onClick={() => onViewChange('kanban')}
        />
        <ViewButton
          label="List"
          icon={Rows3}
          active={view === 'list'}
          onClick={() => onViewChange('list')}
        />
      </div>
    </div>
  )
}

function ViewButton({
  label,
  icon: Icon,
  active,
  onClick,
}: {
  label: string
  icon: IconType
  active: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'inline-flex h-full items-center gap-1.5 rounded-[6px] px-3 text-sm font-medium transition-colors duration-150 ease-out',
        active ? 'bg-brand text-brand-fg' : 'text-app-hint hover:text-app-text',
      )}
    >
      <Icon size={15} aria-hidden="true" />
      {label}
    </button>
  )
}
